<aside class="filters-sidebar">
  <div class="filters-header">
    <h3 class="filters-title">Filtros</h3>
    @if (hasActiveFilters()) {
      <button class="btn-clear" (click)="clearFilters()">
        Limpar filtros
      </button>
    }
  </div>

  <!-- Filtro por Veículo -->
  <div class="filter-section">
    <button 
      class="filter-section-header"
      (click)="toggleSection('vehicle')"
      [attr.aria-expanded]="sections.vehicle()"
    >
      <span class="filter-section-title">VEÍCULO COMPATÍVEL</span>
      <span class="filter-section-icon">
        {{ sections.vehicle() ? '−' : '+' }}
      </span>
    </button>

    @if (sections.vehicle()) {
      <div class="filter-section-content">
        <!-- Marca -->
        <div class="form-group">
          <label class="form-label">Marca</label>
          <select 
            class="form-control"
            [value]="filters.marcaVeiculo || ''"
            (change)="onMakeChange($any($event.target).value)"
          >
            <option value="">Todas as marcas</option>
            @for (make of vehicleMakes(); track make.id) {
              <option [value]="make.id">{{ make.nome }}</option>
            }
          </select>
        </div>

        <!-- Modelo -->
        @if (filters.marcaVeiculo && vehicleModels().length > 0) {
          <div class="form-group">
            <label class="form-label">Modelo</label>
            <select 
              class="form-control"
              [value]="filters.modeloVeiculo || ''"
              (change)="onModelChange($any($event.target).value)"
            >
              <option value="">Todos os modelos</option>
              @for (model of vehicleModels(); track model.id) {
                <option [value]="model.id">{{ model.nome }}</option>
              }
            </select>
          </div>
        }

        <!-- Ano -->
        <div class="form-group">
          <label class="form-label">Ano</label>
          <select 
            class="form-control"
            [value]="filters.anoVeiculo || ''"
            (change)="onYearChange($any($event.target).value)"
          >
            <option value="">Todos os anos</option>
            @for (year of vehicleYears(); track year) {
              <option [value]="year">{{ year }}</option>
            }
          </select>
        </div>
      </div>
    }
  </div>

  <div class="filter-divider"></div>

  <!-- Filtro por Categoria -->
  <div class="filter-section">
    <button 
      class="filter-section-header"
      (click)="toggleSection('category')"
      [attr.aria-expanded]="sections.category()"
    >
      <span class="filter-section-title">CATEGORIA</span>
      <span class="filter-section-icon">
        {{ sections.category() ? '−' : '+' }}
      </span>
    </button>

    @if (sections.category()) {
      <div class="filter-section-content">
        @for (category of categories(); track category.id) {
          <label class="checkbox-label">
            <input 
              type="checkbox"
              [checked]="selectedCategories.includes(category.id)"
              (change)="onCategoryChange(category.id, $any($event.target).checked)"
            />
            <span>{{ category.nome }}</span>
          </label>
        }
      </div>
    }
  </div>

  <div class="filter-divider"></div>

  <!-- Filtro por Disponibilidade -->
  <div class="filter-section">
    <button 
      class="filter-section-header"
      (click)="toggleSection('stock')"
      [attr.aria-expanded]="sections.stock()"
    >
      <span class="filter-section-title">DISPONIBILIDADE</span>
      <span class="filter-section-icon">
        {{ sections.stock() ? '−' : '+' }}
      </span>
    </button>

    @if (sections.stock()) {
      <div class="filter-section-content">
        <label class="checkbox-label">
          <input 
            type="checkbox"
            [checked]="filters.apenasEmEstoque || false"
            (change)="onStockChange($any($event.target).checked)"
          />
          <span>Apenas em estoque</span>
        </label>
      </div>
    }
  </div>

  <div class="filter-divider"></div>

  <!-- Filtro por Preço -->
  <div class="filter-section">
    <button 
      class="filter-section-header"
      (click)="toggleSection('price')"
      [attr.aria-expanded]="sections.price()"
    >
      <span class="filter-section-title">PREÇO</span>
      <span class="filter-section-icon">
        {{ sections.price() ? '−' : '+' }}
      </span>
    </button>

    @if (sections.price()) {
      <div class="filter-section-content">
        <div class="price-inputs">
          <div class="form-group">
            <label class="form-label">Mínimo</label>
            <input 
              type="number"
              class="form-control"
              placeholder="R$ 0"
              [value]="filters.precoMin || ''"
              (input)="onPriceMinChange($any($event.target).value)"
              min="0"
              step="10"
            />
          </div>
          <div class="form-group">
            <label class="form-label">Máximo</label>
            <input 
              type="number"
              class="form-control"
              placeholder="R$ 10000"
              [value]="filters.precoMax || ''"
              (input)="onPriceMaxChange($any($event.target).value)"
              min="0"
              step="10"
            />
          </div>
        </div>
      </div>
    }
  </div>
</aside>

